export default {
  path: '/control_units',
  name: 'control_units',
  component: () => import('../components/controlunit/Layout'),
  redirect: { name: 'ControlUnitList' },
  meta: {
    breadcrumb: 'controlunit.controlunits',
  },
  children: [
    {
      name: 'ControlUnitList',
      path: '',
      component: () => import('../views/controlunit/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'ControlUnitCreate',
      path: 'new',
      component: () => import('../views/controlunit/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'ControlUnitUpdate',
      path: ':id/edit',
      component: () => import('../views/controlunit/Update'),
      meta: {
        breadcrumb: 'controlunit.controlunit',
      },
    },
    {
      name: 'ControlUnitShow',
      path: ':id',
      component: () => import('../views/controlunit/Show'),
      meta: {
        breadcrumb: 'controlunit.controlunit',
      },
    }
  ]
};
